
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nnderckiswvsylfcpggh.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5uZGVyY2tpc3d2c3lsZmNwZ2doIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY3OTUwMjMsImV4cCI6MjA1MjM3MTAyM30.980Xpkfs5nUyCiwQf-Vh7asPqXFzeFMdYOVbegheHE4";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);
